import React from 'react';
import { motion } from 'framer-motion';
import { useCasesData } from '../data/siteData';

const UseCases = () => {
  const { sectionTag, title, subtitle, cases } = useCasesData;

  return (
    <section id="use-cases" className="py-24 lg:py-32 border-t border-white/10" data-testid="use-cases-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16">
          <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#FF7A00]/70 mb-4 block">{sectionTag}</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-4xl mb-4">{title}</h2>
          <p className="text-base text-white/40 max-w-2xl">{subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">
          {cases.map((c, i) => (
            <motion.div key={c.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.08 }}
              className="group bg-[#141414] border border-white/10 rounded-2xl overflow-hidden hover:border-[#FF7A00]/30 transition-colors"
              data-testid={`use-case-card-${c.id}`}>
              <div className="relative h-44 overflow-hidden">
                <img src={c.image} alt={c.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#141414] via-transparent to-transparent" />
              </div>
              <div className="p-6">
                <h3 className="text-lg font-bold mb-2">{c.title}</h3>
                <p className="text-sm text-white/40 leading-relaxed mb-4">{c.description}</p>
                <div className="flex flex-wrap gap-2">
                  {c.tags.map((tag, j) => (
                    <span key={j} className="font-mono text-[10px] tracking-wider uppercase px-2.5 py-1 rounded-full border border-white/10 text-white/40">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
